import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { PedidoSetorGepComponent } from './pedido-setor-gep.component';
import { PedidoSetorGepMultiselectComponent } from './multiselect';
import { PedidoSetorGepBadgeComponent } from './badge';
import { PedidoSetorGepPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        PopoverModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        PedidoSetorGepComponent,
        PedidoSetorGepMultiselectComponent,
        PedidoSetorGepBadgeComponent,

        // Pipes
        PedidoSetorGepPipe
    ],
    exports: [
        PedidoSetorGepComponent,
        PedidoSetorGepMultiselectComponent,
        PedidoSetorGepBadgeComponent,

        // Pipes
        PedidoSetorGepPipe
    ],
    providers: [
        // Pipes
        PedidoSetorGepPipe
    ]
})
export class PedidoSetorGepModule { }
